// extracted by mini-css-extract-plugin
module.exports = {"today":"TodayWeather_today__1Fv2B","icon":"TodayWeather_icon__1eWHM","desc":"TodayWeather_desc__21iBk","temp":"TodayWeather_temp__1I5A2","other":"TodayWeather_other__2vx3t"};